import {
  Fieldset,
  FieldsetLegend,
} from "@imi/ui/components/Fieldset/Fieldset.js";
import { UnitsOptions } from "@src/core/engine/units/unitsRepository";
import { useTranslation } from "react-i18next";
import { useUnitsForm } from "../hooks/useUnitsForm";

type FluidPropertiesProps = {
  form: ReturnType<typeof useUnitsForm>["form"];
  unitsOptions: UnitsOptions;
};

export function FluidProperties({ form, unitsOptions }: FluidPropertiesProps) {
  const { t } = useTranslation("settings", { keyPrefix: "units" });

  return (
    <Fieldset>
      <FieldsetLegend>{t("fluidProperties.title")}</FieldsetLegend>
      <form.AppField name="waterHardness">
        {(field) => (
          <field.Select label={t("fluidProperties.fields.waterHardness")}>
            {unitsOptions.waterHardness.options.map((option) => (
              <option key={option.id} value={option.id}>
                {option.label} {option.default ? t("defaultOption") : ""}
              </option>
            ))}
          </field.Select>
        )}
      </form.AppField>

      <form.AppField name="density">
        {(field) => (
          <field.Select label={t("fluidProperties.fields.density")}>
            {unitsOptions.density.options.map((option) => (
              <option key={option.id} value={option.id}>
                {option.label} {option.default ? t("defaultOption") : ""}
              </option>
            ))}
          </field.Select>
        )}
      </form.AppField>

      <form.AppField name="kinematicViscosity">
        {(field) => (
          <field.Select label={t("fluidProperties.fields.kinematicViscosity")}>
            {unitsOptions.kinematicViscosity.options.map((option) => (
              <option key={option.id} value={option.id}>
                {option.label} {option.default ? t("defaultOption") : ""}
              </option>
            ))}
          </field.Select>
        )}
      </form.AppField>
    </Fieldset>
  );
}
